import { Result } from '../../../common-models/Result';
import { HttpServiceBase } from '../../../common-services/Http/HttpServiceBase';
import { CreateLocationInput } from './CreateLocationInput';
import { CreateLocationOutput } from './CreateLocationOutput';

export class CreateLocationService extends HttpServiceBase {

  handle = (input: CreateLocationInput): Promise<Result<CreateLocationOutput> | null> =>
    this.http.post<Result<CreateLocationOutput>, CreateLocationInput>(`${this.baseUrlSislogApi}/v2/location/admin`, input);
}
